import { render } from "./NotificationListPage.vue?vue&type=template&id=27ddc294&scoped=true"
import script from "./NotificationListPage.vue?vue&type=script&lang=js"
export * from "./NotificationListPage.vue?vue&type=script&lang=js"

import "./NotificationListPage.vue?vue&type=style&index=0&id=27ddc294&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27ddc294"

export default script